<div class="simple-card" [ngClass]="{ 'region-card': isRegion, 'landscape-card': !isRegion }"
  [routerLink]="['/browse/search']" [queryParams]="isRegion ? { country: item.name } : { tag: item.id }">
  >
  <div class="filter"></div>
  <div class="background">
    <img class="background-image" [src]="
        'assets/images/browse/' +
        (isRegion ? 'world-regions' : 'landscapes') +
        '/' +
        item.name +
        '.jpg'
      " [alt]="item.name" />
  </div>
  <div class="card-info">{{ translationPath | translate }}</div>
</div>